/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

/* Veloura password-page overlay fix (vel-pw-fix-11h) — runs on password gate HTML */
(function velouraPasswordOverlayFix() {
  if (typeof document === 'undefined') return;
  if (!document.querySelector('.password-dialog, [data-vel-launch], #password-form')) return;

  var css = document.createElement('style');
  css.setAttribute('data-vel-pw-fix', '11h');
  css.textContent = [
    'html,body{margin:0!important;background:#061912!important;color:#FDF7ED!important;}',
    'dialog,dialog.password-dialog,dialog-component#password-form,#password-form,.password-dialog{',
    'display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;',
    'width:0!important;height:0!important;max-width:0!important;max-height:0!important;',
    'position:fixed!important;z-index:-1!important;background:transparent!important;}',
    '#MainContent.vel-launch,.vel-launch{position:relative!important;z-index:10!important;visibility:visible!important;',
    'opacity:1!important;display:grid!important;min-height:100dvh!important;width:100%!important;place-items:center!important;',
    'padding:clamp(24px,4vw,48px)!important;color:#FDF7ED!important;background:#061912!important;overflow:hidden!important;}',
    '.vel-launch__bg{position:absolute!important;inset:0!important;z-index:0!important;pointer-events:none!important;',
    'background:radial-gradient(ellipse 80% 60% at 50% 0%,rgba(198,161,91,.22),transparent 55%),linear-gradient(165deg,#0B3D2E 0%,#061912 55%,#0A2F24 100%)!important;}',
    '.vel-launch__inner{position:relative!important;z-index:2!important;width:min(640px,100%)!important;text-align:center!important;}',
    '.vel-launch__eyebrow{margin:0 0 12px!important;font:600 11px/1.2 system-ui,sans-serif!important;letter-spacing:.28em!important;text-transform:uppercase!important;color:#C6A15B!important;}',
    '.vel-launch__title{margin:0 0 14px!important;font:400 clamp(2.4rem,7vw,3.75rem)/1.05 Georgia,serif!important;color:#FDF7ED!important;}',
    '.vel-launch__lede{margin:0 auto 36px!important;max-width:34em!important;font:400 clamp(1rem,2.2vw,1.125rem)/1.55 system-ui,sans-serif!important;color:rgba(253,247,237,.78)!important;}',
    '.vel-launch__lede strong{color:#C6A15B!important;}',
    '.vel-launch__timer{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:clamp(8px,2vw,16px)!important;margin:0 0 28px!important;}',
    '.vel-launch__unit{background:rgba(253,247,237,.06)!important;border:1px solid rgba(198,161,91,.35)!important;padding:clamp(14px,2.5vw,22px) 8px!important;}',
    '.vel-launch__unit span{display:block!important;font:650 clamp(1.6rem,5vw,2.4rem)/1 system-ui,sans-serif!important;color:#FDF7ED!important;}',
    '.vel-launch__unit small{display:block!important;margin-top:8px!important;font:500 10px/1 system-ui,sans-serif!important;letter-spacing:.18em!important;text-transform:uppercase!important;color:rgba(198,161,91,.9)!important;}',
    '.vel-launch__note{margin:0!important;font:400 13px/1.4 system-ui,sans-serif!important;color:rgba(253,247,237,.55)!important;}',
    '.vel-launch-staff>button.vel-launch-staff__btn{display:none!important;}',
    'details.vel-pw-staff{position:fixed!important;bottom:16px!important;right:16px!important;z-index:50!important;}',
    'details.vel-pw-staff>summary{list-style:none!important;cursor:pointer!important;border:1px solid rgba(198,161,91,.5)!important;background:rgba(6,25,18,.92)!important;color:#FDF7ED!important;font:600 11px/1 system-ui,sans-serif!important;letter-spacing:.12em!important;text-transform:uppercase!important;padding:10px 14px!important;}',
    'details.vel-pw-staff form{margin-top:8px!important;padding:12px!important;background:rgba(6,25,18,.95)!important;border:1px solid rgba(198,161,91,.35)!important;display:grid!important;gap:8px!important;}',
    'details.vel-pw-staff input,details.vel-pw-staff button{font:500 14px/1.2 system-ui,sans-serif!important;padding:10px 12px!important;border:1px solid rgba(198,161,91,.35)!important;}',
    'details.vel-pw-staff button{background:#C6A15B!important;color:#061912!important;font-weight:700!important;cursor:pointer!important;}'
  ].join('');
  (document.head || document.documentElement).appendChild(css);

  function kill() {
    document.querySelectorAll('dialog.password-dialog, dialog-component#password-form, #password-form').forEach(function (el) {
      try { if (el.tagName === 'DIALOG' && el.open) el.close(); } catch (e) {}
      el.setAttribute('hidden', '');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('width', '0', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('z-index', '-1', 'important');
      el.style.setProperty('background', 'transparent', 'important');
    });
  }
  kill();
  document.addEventListener('DOMContentLoaded', kill);
  window.addEventListener('load', kill);
  setTimeout(kill, 0);
  setTimeout(kill, 200);

  function ensureStaff() {
    if (document.querySelector('details.vel-pw-staff, details.vel-launch-staff, details.vel-launch-staff-gate')) return;
    if (!document.body) return;
    var d = document.createElement('details');
    d.className = 'vel-pw-staff';
    d.innerHTML = '<summary>Staff / password</summary><form method="post" action="/password" accept-charset="UTF-8">' +
      '<input type="hidden" name="form_type" value="storefront_password" />' +
      '<input type="hidden" name="utf8" value="\u2713" />' +
      '<input type="password" name="password" placeholder="Password" autocomplete="current-password" />' +
      '<button type="submit">Enter</button></form>';
    document.body.appendChild(d);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureStaff);
  else ensureStaff();
  document.documentElement.setAttribute('data-vel-pw-fix', '11h');
})();
